import { Box } from "@mui/system";
import NotificationMediator from "./common/components/notification/NotificationMediator";
import React, { FC, useEffect, useRef } from "react";
import LoadingSpinnerBackdrop from "common/components/progress/LoadingSpinner";
import { Redirect, Route, Switch, useLocation } from "react-router";
/*import { LoginCallback } from "@okta/okta-react";*/
import Header from "./common/components/header/Header";
import Footer from "./common/components/footer/Footer";
import Project from "./components/project/Project";
import Landing from "./components/landing/Landing";
import useLinkStore from "common/store/LinksStore";
import useLookupsStore from "common/store/LookupsStore";
import { US_English_Locale } from "common/constants/GlobalValues";
import useSettingsStore from "common/store/SettingsStore";
import OpenGraphMetaTag from "common/metaTags/OpenGraphMetaTags";
import LocalizedRoute from "common/components/localizedRoute/LocalizedRoute";
import AuthResponse from "components/auth/AuthResponse";

const AppSpecific: FC = () => {
  const { loading: loadingLinks, hasErrors } = useLinkStore();
  const { settings, fetchSettings } = useSettingsStore();
  const { fetchLookups, loading: loadingLookups } = useLookupsStore();

    const location = useLocation();
    const headerRef = useRef<HTMLElement>(null);

  useEffect(() => {
    fetchSettings();
  }, [fetchSettings]);

  useEffect(() => {
    console.log(`In AppSpecific, settings is: ${settings?.apiBaseUrl}`);
  });

  useEffect(() => {
    if (settings.apiBaseUrl !== "") {
      fetchLookups(settings.apiBaseUrl);
    }
    console.log(`In fetchLookups, settings is: ${settings?.apiBaseUrl}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Empty dependency array ensures it runs only once on mount

  useEffect(() => {
      if (headerRef.current) {
          // Set boolean attributes (presence = true, absence = false)
          headerRef.current.toggleAttribute('search', true);
          headerRef.current.toggleAttribute('langselector', true);
          headerRef.current.toggleAttribute('loginicon', true);
      }
  }, []);

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
        }}
      >
        <OpenGraphMetaTag />
              <Header fullWidth={true}></Header>
       {/* <emr-corporate-header ref={headerRef} />*/}
        <Box sx={{ flex: 1 }}>
          {loadingLinks || loadingLookups || hasErrors ? (
            <LoadingSpinnerBackdrop />
          ) : (
            <Switch>
              <Route path="/" exact>
                <Redirect to={`/${US_English_Locale}/`} />
              </Route>
              <Route path="/emr-sso-auth/" component={AuthResponse} />
              <Route path="/project/:projectID">
                <Redirect to={`/${US_English_Locale}${location.pathname}`} />
              </Route>
              {/*<Route path="/account/login/callback" exact={true} component={LoginCallback} />*/}
              <Route path="/account/logout/callback" exact={true} >
                <Redirect to={`/${US_English_Locale}/`} />
              </Route>
              <LocalizedRoute desc="Expecting Project" path={`/:locale/project/:projectID`} component={Project} />
              <LocalizedRoute desc="Expecting Landing" path={`/:locale/`} component={Landing} />
            </Switch>
          )}
        </Box>
              {/*<Footer fullWidth={true}></Footer>*/}
        <emr-legal-footer />
        <NotificationMediator />
      </Box>
    </>
  );
};

export default AppSpecific;
